import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from './index.module.less';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import { AFFILIATE_SIGNUP_URL } from '../../constants';
import EarningsCalculator from '../EarningsCalculator';

// 卖点行：设计稿 #10899:3681 ~ #10899:3692
const HIGHLIGHTS = ['Free to join', 'Strong commission potential', 'No minimum payout', 'Monthly payouts'];

// 13×8 的对勾，2px 描边居中对齐，故导出画布为 15×11
const CheckIcon = () => (
  <svg className={styles.check} width="15" height="11" viewBox="0 0 15 11" fill="none" aria-hidden="true">
    <path d="M1 4.42857L5.72727 9L14 1" stroke="#19A358" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

/** Hero：设计稿 #10899:3670 */
const Hero: React.FC<{ isModal?: boolean }> = ({ isModal = false }) => {
  const { t } = useTranslation('common');
  const Heading = isModal ? 'h2' : 'h1';

  const onApply = () => {
    ga_logEvent(EventName.click_affiliate_invite_cta, { position: isModal ? 'modal_hero' : 'page_hero' });
    window.open(AFFILIATE_SIGNUP_URL, '_blank');
  };

  return (
    <section className={styles.container}>
      <div className={styles.intro}>
        <div className={styles.badge}>
          <span className={styles.badgeText}>{t('Erasa · Affiliate Program')}</span>
        </div>
        <Heading className={styles.headline}>
          <span className={styles.percent}>20%</span>{' '}
          <span className={styles.headlineText}>{t('Referral Commission')}</span>
        </Heading>
        <p className={styles.subtitle}>
          {t('Earn 20% of what each referred customer pays during their first 6 months.')}
        </p>
      </div>

      <button type="button" className={styles.cta} onClick={onApply}>
        {t('Get Your Referral Link')}
      </button>

      <ul className={styles.highlights}>
        {HIGHLIGHTS.map((item) => (
          <li key={item} className={styles.highlight}>
            <CheckIcon />
            <span>{t(item)}</span>
          </li>
        ))}
      </ul>

      {/* 收益计算器在设计稿里属于 Hero 区块的最后一个子节点，因此放在这里由父级 gap 统一控制间距 */}
      <EarningsCalculator />
    </section>
  );
};

export default Hero;
